export default "__VITE_ASSET__BBLiJak$__"